export const fullsizeVideo = (function ($) {

    let $video = $('.js-toggle-video');

    function toggleVideo ($this) {

        let $videoHref = $this.next().attr("data-src");

        if (!$this.hasClass("hide-poster")) {
            $this.next().attr("src", $videoHref);
            $this.addClass("hide-poster");
            setTimeout(() => {
                // scroll to video
                $("html,body").animate({
                    scrollTop: $this.offset().top - 50,
                }, 0);
            }, 400);
        }

    }

    function init() {
        $video.click(function (e) {
            e.preventDefault();
            let $this = $(this);

            toggleVideo($this);
        });
    }

    return {
        init: init
    }

})(jQuery);